<div
  class="p-2 md:p-4 rounded-none shadow-none flex flex-col md:flex-row md:bg-white md:rounded-xl md:shadow-sm gap-6 mx-2"
  [class.opacity-50]="isLoading">

  <div class="flex-1 flex flex-col gap-4">
    <h2 class="text-lg font-semibold text-center ">
      {{ "::NewOrder" | abpLocalization }}
    </h2>

    <form [formGroup]="form" (ngSubmit)="submit()" id="angular-form" [attr.aria-busy]="isLoading">

      <div class="flex flex-col gap-2">
        <h3 class="font-semibold text-metro-blue-secondary text-base">
          {{'::PickupOptions' | abpLocalization}}
        </h3>
        <label
          class="flex items-start justify-between w-full px-3 py-2 border rounded-xl cursor-pointer bg-gray-50 hover:bg-gray-100">
          <div class="flex flex-col gap-1 flex-1">
            <span class="font-medium block">
              {{'::MeetWithSommelier' | abpLocalization}}
            </span>
            <span class="font-medium block  text-metro-black">
              {{'::ArrangePersonalMeeting' | abpLocalization}}
            </span>
          </div>
          <input type="radio" [value]="DeliveryMethod.MeetWithSommelier" formControlName="deliveryMethod" name="deliveryMethod"
            [disabled]="isLoading"
            class="appearance-none h-5 w-5 rounded-full border-4 border-metro-blue checked:bg-metro-blue checked:border-metro-blue-secondary flex-shrink-0 mt-1" />
        </label>
        <label
          class="flex items-start justify-between w-full px-3 py-2 border rounded-xl cursor-pointer bg-gray-50 hover:bg-gray-100">
          <div class="flex flex-col gap-1 flex-1">
            <span class="font-medium block">
              {{'::Pickup' | abpLocalization}}
            </span>
            <span class="font-medium block  text-metro-black">
              {{'::SelectPickupLocation' | abpLocalization}}
            </span>
          </div>
          <input type="radio" [value]="DeliveryMethod.Pickup" formControlName="deliveryMethod" name="deliveryMethod" [disabled]="isLoading"
            class="appearance-none h-5 w-5 rounded-full border-4 border-metro-blue checked:bg-metro-blue checked:border-metro-blue-secondary flex-shrink-0 mt-1" />
        </label>
        @if (showPickupSelect) {
        <div
          [class]="form.get('deliveryMethod')?.value === DeliveryMethod.Pickup ? 'block fade-in-animation' : 'block fade-out-animation'">
          <app-metro-form-select [placeholder]="'::SelectPickupLocation' | abpLocalization" [options]="pickUpsOptions"
            formControlName="shippingAddressLine" [disabled]="isLoading" [allowSearch]="false" size="md"
            [skipValidation]="true"
            [error]="form.get('shippingAddressLine')?.invalid && form.get('shippingAddressLine')?.touched ? '::ThisFieldIsRequired' : null">
          </app-metro-form-select>
        </div>
        }
      </div>

      <!-- Sección de Datos Personales / Facturación -->
      <div class="flex flex-col gap-2 mt-4" [class.hidden]="!shouldShowPersonalInformation">
        <h3 class="font-semibold text-metro-blue-secondary text-base">
          {{'::PersonalInformation' | abpLocalization}}
        </h3>

        <div class="flex gap-2 w-full mb-1" [class.hidden]="!shouldShowDni">
          <!-- El select de tipo de documento: Ancho fijo para evitar que desplace al input -->
          <div class="w-[120px] shrink-0" [class.hidden]="form.get('paymentMethod').value !== 'card'">
            <select id="form-checkout__identificationType" [disabled]="isLoading"
              class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50 w-full">
              <option value="">DNI</option>
            </select>
          </div>

          <div class="flex-1 relative">
            <input id="form-checkout__identificationNumber" formControlName="dni" [placeholder]="isLoadingProfile ? 'Cargando...' : 'DNI'"
              [disabled]="isLoading" [skipValidation]="true"
              class="block w-full input-base placeholder-metro-blue-secondary placeholder-opacity-50 text-base px-3 py-2"
              [ngClass]="{'border-red-500 ring-1 ring-red-400': form.get('dni')?.invalid && form.get('dni')?.touched}" />
            @if (form.get('dni')?.invalid && form.get('dni')?.touched) {
            <p class="absolute left-0 top-full text-[10px] text-red-500 mt-0.5 leading-none">
              {{ '::ThisFieldIsRequired' | abpLocalization }}
            </p>
            }
          </div>
        </div>

        <!-- El teléfono solo se muestra si el perfil está incompleto y es cliente -->
        <app-metro-form-input *ngIf="shouldShowPhone" formControlName="phoneNumber"
          [placeholder]="'::Telephone' | abpLocalization" size="md" type="tel" [disabled]="isLoading" appArMobileMask
          [skipValidation]="true"
          [error]="form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched ? '::ThisFieldIsRequired' : null"></app-metro-form-input>

        <!-- La dirección y provincia solo se muestran si al perfil le falta alguna de las dos -->
        <ng-container *ngIf="shouldShowAddress">
          <app-metro-form-input formControlName="profileAddress"
            [placeholder]="'::Address' | abpLocalization" size="md" type="text" [disabled]="isLoading"
            [skipValidation]="true"
            [error]="form.get('profileAddress')?.invalid && form.get('profileAddress')?.touched ? '::ThisFieldIsRequired' : null"></app-metro-form-input>

          <app-metro-form-select formControlName="profileProvince"
            [placeholder]="'::Province' | abpLocalization" [options]="provinceOptions"
            [allowSearch]="false" [allowClear]="false" [disabled]="isLoading"
            [error]="form.get('profileProvince')?.invalid && form.get('profileProvince')?.touched ? '::ThisFieldIsRequired' : null"></app-metro-form-select>
        </ng-container>
      </div>

      <div class="flex flex-col gap-2 mt-4">
        <h3 class="font-semibold text-metro-blue-secondary text-base">
          {{'::PaymentMethod' | abpLocalization}}
        </h3>
        <label
          class="flex items-center justify-between w-full px-3 py-2 border rounded-xl cursor-pointer bg-gray-50 hover:bg-gray-100">
          <span class="font-medium">{{'::CreditCard' | abpLocalization}}</span>
          <input type="radio" value="card" formControlName="paymentMethod" name="paymentMethod" [disabled]="isLoading"
            class="appearance-none h-5 w-5 rounded-full border-4 border-metro-blue checked:bg-metro-blue checked:border-metro-blue-secondary" />
        </label>
        <label
          class="flex items-center justify-between w-full px-3 py-2 border rounded-xl cursor-pointer bg-gray-50 hover:bg-gray-100">
          <span class="font-medium">{{'::BankTransfer' | abpLocalization}}</span>
          <input type="radio" value="bank" formControlName="paymentMethod" name="paymentMethod" [disabled]="isLoading"
            class="appearance-none h-5 w-5 rounded-full border-4 border-metro-blue checked:bg-metro-blue checked:border-metro-blue-secondary" />
        </label>
        @if (isAllariaActive) {
        <label
          class="flex items-center justify-between w-full px-3 py-2 border rounded-xl cursor-pointer bg-gray-50 hover:bg-gray-100">
          <span class="font-medium">Allaria+</span>
          <input type="radio" value="allaria" formControlName="paymentMethod" name="paymentMethod" [disabled]="isLoading"
            class="appearance-none h-5 w-5 rounded-full border-4 border-metro-blue checked:bg-metro-blue checked:border-metro-blue-secondary" />
        </label>
        }
      </div>

      @if (this.form.get('paymentMethod').value === 'bank') {
      <div class="flex flex-col gap-2 mt-1">
        <app-metro-form-input formControlName="bankHolder" size="md" type="text"
          [disabled]="isLoading"></app-metro-form-input>
        <app-metro-form-input formControlName="bankCbu" size="md" type="text"
          [disabled]="isLoading"></app-metro-form-input>
        <app-metro-form-input formControlName="bankAlias" size="md" type="text"
          [disabled]="isLoading"></app-metro-form-input>
      </div>
      }
    </form>

    @if (this.form.get('paymentMethod').value === 'card') {

    <!-- Selector de Sub-Proveedor de Tarjeta si ambos están activos -->
    @if (isPaywayActive && isMercadoPagoActive) {
    <div class="flex gap-2 mb-3 mt-1">
      <button type="button" (click)="selectCardProvider('MercadoPago')"
        [class]="selectedCardProvider === 'MercadoPago' ? 'flex-1 py-2 px-3 border-2 border-metro-blue bg-blue-50 font-semibold rounded-xl text-metro-blue text-sm' : 'flex-1 py-2 px-3 border border-gray-200 bg-white text-gray-600 rounded-xl text-sm hover:bg-gray-50'">
        Mercado Pago
      </button>
      <button type="button" (click)="selectCardProvider('Payway')"
        [class]="selectedCardProvider === 'Payway' ? 'flex-1 py-2 px-3 border-2 border-metro-blue bg-blue-50 font-semibold rounded-xl text-metro-blue text-sm' : 'flex-1 py-2 px-3 border border-gray-200 bg-white text-gray-600 rounded-xl text-sm hover:bg-gray-50'">
        Tarjeta de Crédito/Débito
      </button>
    </div>
    }

    <!-- ===== FORMULARIO PAYWAY / DECIDIR ===== -->
    @if (isPaywayActive && (!isMercadoPagoActive || selectedCardProvider === 'Payway')) {
    <form id="form-payway" class="flex flex-col gap-3 mt-2" (ngSubmit)="submitPayway()" autocomplete="on">
      <input type="text" id="payway-holder" data-decidir="card_holder_name" autocomplete="cc-name" placeholder="Titular de la tarjeta"
        [disabled]="isLoading"
        class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />
      <input type="email" id="payway-email" autocomplete="email" placeholder="E-mail"
        [disabled]="isLoading"
        class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />
      <input type="text" id="payway-card-number" data-decidir="card_number" autocomplete="cc-number" placeholder="Número de tarjeta" maxlength="19"
        [disabled]="isLoading"
        (input)="onPaywayCardNumberInput($event)"
        class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />

      <div class="flex gap-2">
        <input type="text" id="payway-expiration-date" autocomplete="cc-exp" placeholder="MM/YY"
          [disabled]="isLoading"
          (input)="onExpirationInput($event)"
          class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50 w-2/3" />
        <input type="text" id="payway-cvv" data-decidir="security_code" autocomplete="cc-csc" placeholder="CVV" maxlength="4"
          [disabled]="isLoading"
          class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50 w-1/3" />
      </div>
      <!-- Campos ocultos requeridos por el SDK Decidir v2 para createToken() -->
      <input type="hidden" id="payway-exp-month" data-decidir="card_expiration_month" />
      <input type="hidden" id="payway-exp-year" data-decidir="card_expiration_year" />
      <input type="hidden" id="payway-doc-type" data-decidir="card_holder_doc_type" />
      <input type="hidden" id="payway-doc-number" data-decidir="card_holder_doc_number" />

      <!-- Selector de cuotas -->
      <div class="flex flex-col gap-2 mt-1">
        <label class="text-sm font-semibold text-metro-blue-secondary">Cuotas</label>
        @if (isLoadingInstallments) {
          <p class="text-sm text-gray-400">Calculando cuotas...</p>
        } @else {
          <div class="flex flex-col gap-1">
            @for (opt of installmentOptions; track opt.quotas) {
            <label
              class="flex items-center justify-between w-full px-3 py-2 border rounded-xl cursor-pointer"
              [class.bg-metro-blue]="selectedInstallments === opt.quotas"
              [class.text-white]="selectedInstallments === opt.quotas"
              [class.bg-gray-50]="selectedInstallments !== opt.quotas"
              [class.hover:bg-gray-100]="selectedInstallments !== opt.quotas">
              <div class="flex flex-col">
                <span class="font-semibold text-sm">
                  {{ opt.quotas }}x de ${{ opt.monthlyPayment | number:'1.2-2' }}
                  <span *ngIf="opt.isNoInterest" class="text-xs font-normal ml-1
                    {{ selectedInstallments === opt.quotas ? 'text-green-200' : 'text-green-600' }}">
                    (sin interés)
                  </span>
                </span>
                <span class="text-xs
                  {{ selectedInstallments === opt.quotas ? 'text-blue-100' : 'text-gray-400' }}">
                  Total: ${{ opt.total | number:'1.2-2' }}
                  <span *ngIf="!opt.isNoInterest"> ({{ opt.interestRate }}% de interés)</span>
                </span>
              </div>
              <input type="radio" [value]="opt.quotas" [(ngModel)]="selectedInstallments"
                [ngModelOptions]="{standalone: true}"
                class="appearance-none h-5 w-5 rounded-full border-4 border-white checked:bg-white flex-shrink-0" />
            </label>
            }
          </div>
        }
      </div>
    </form>
    }

    <!-- ===== FORMULARIO MERCADO PAGO ===== -->
    @if (isMercadoPagoActive && (!isPaywayActive || selectedCardProvider === 'MercadoPago')) {
    <form id="form-checkout" class="flex flex-col gap-2" autocomplete="on">
      <input type="text" id="form-checkout__cardholderName" autocomplete="cc-name" placeholder="Titular de la tarjeta"
        [disabled]="isLoading"
        class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />
      <input type="email" id="form-checkout__cardholderEmail" autocomplete="email" placeholder="E-mail"
        [disabled]="isLoading"
        class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />
      <input type="text" id="form-checkout__cardNumber" autocomplete="cc-number" placeholder="Número de la tarjeta"
        [disabled]="isLoading"
        class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />

      <div class="flex gap-2">
        <input type="text" autocomplete="cc-exp" id="form-checkout__expirationDate" placeholder="MM/YY"
          [disabled]="isLoading"
          class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />
        <input type="text" autocomplete="cc-csc" id="form-checkout__securityCode" placeholder="CVV"
          [disabled]="isLoading"
          class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50" />
      </div>

      <div class="flex flex-col gap-2">
        <select id="form-checkout__issuer" [disabled]="isLoading"
          class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50">
        </select>
        <!-- Select de cuotas para Mercado Pago -->
        <select id="form-checkout__installments" [disabled]="isLoading" class="text-base px-3 py-2 input-base placeholder-metro-blue-secondary placeholder-opacity-50">
        </select>
      </div>
    </form>
    }
    }
  </div>

  <div class="flex-1 flex flex-col mt-5">


    <div class="flex-1 flex flex-col ">
      <div class="mb-6">
        <app-coupon-input 
          [orderTotal]="total" 
          [sommelierId]="sommelierUserId"
          [items]="cartItems"
          (couponApplied)="onCouponApplied($event)"
          (couponRemoved)="onCouponRemoved()">
        </app-coupon-input>
      </div>

      <!-- Order Summary -->
      <div class="text-sm text-metro-blue-secondary">
        <h2 class="text-lg font-semibold">{{'::OrderSummary' | abpLocalization}}</h2>
        @for (item of cartItems; track $index) {
        <div class="flex justify-between mt-2">
          <span class="text-metro-blue">{{ item.wineName }} x {{ item.quantity }}</span>
          <span>${{ item.unitPrice * item.quantity | number:'1.2-2'}}</span>
        </div>
        }

        <div class="flex justify-between mt-4">
          <span>Subtotal:</span>
          <span>${{ subtotal | number:'1.2-2' }}</span>
        </div>

        <div class="flex justify-between">
          <span>IVA 21%:</span>
          <span>${{ tax | number:'1.2-2' }}</span>
        </div>

        @if (discountAmount > 0) {
        <div class="flex justify-between text-green-600 font-medium">
          <span>{{ '::Discount' | abpLocalization }} ({{ appliedCouponDisplay }}):</span>
          <span>-${{ discountAmount | number:'1.2-2' }}</span>
        </div>
        }

        <div class="flex justify-between font-semibold mt-2 border-t pt-2">
          <span>Total</span>
          <span>${{ displayTotal || totalWithTax | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>

    @if (this.form.get('paymentMethod').value === 'bank') {
    <div class="flex justify-center mt-auto pt-4">
      <button type="submit" form="angular-form" [disabled]="isLoading || form.invalid"
        class="w-full md:w-3/4 bg-metro-blue text-white rounded-xl px-3 py-2 font-semibold disabled:opacity-50">
        {{ isLoading ? 'Procesando...' : ('::Confirm' | abpLocalization) }}
      </button>
    </div>
    }
    @else if (this.form.get('paymentMethod').value === 'card' && isPaywayActive && (!isMercadoPagoActive || selectedCardProvider === 'Payway')) {
    <!-- Botón Payway -->
    <div class="flex flex-col items-center mt-auto pt-4 mb-4 gap-2">
      @if (selectedInstallmentOption && !isLoadingInstallments) {
      <p class="text-xs text-metro-blue-secondary text-center">
        Total a pagar: <strong>${{ totalWithInstallments | number:'1.2-2' }}</strong>
        en {{ selectedInstallments }} cuota{{ selectedInstallments > 1 ? 's' : '' }}
        de <strong>${{ monthlyPayment | number:'1.2-2' }}</strong>
        <span *ngIf="selectedInstallmentOption?.isNoInterest" class="text-green-600"> (sin interés)</span>
      </p>
      }
      <button type="submit" form="form-payway" [disabled]="isLoading || form.invalid"
        class="w-full md:w-3/4 bg-metro-blue text-white rounded-xl px-3 py-2 font-semibold disabled:opacity-50">
        {{ isLoading ? 'Procesando...' : ('::Pay' | abpLocalization) }}
      </button>
      <p class="text-xs text-gray-400">Pago procesado por Payway (Prisma)</p>
    </div>
    }
    @else if (this.form.get('paymentMethod').value === 'allaria') {
    <!-- Botón Allaria+: redirige, no tokeniza tarjeta acá -->
    <div class="flex flex-col items-center mt-auto pt-4 mb-4 gap-2">
      <button type="submit" form="angular-form" [disabled]="isLoading || form.invalid"
        class="w-full md:w-3/4 bg-metro-blue text-white rounded-xl px-3 py-2 font-semibold disabled:opacity-50">
        {{ isLoading ? 'Redirigiendo...' : 'Pagar con Allaria+' }}
      </button>
      <p class="text-xs text-gray-400">Vas a completar el pago en Allaria+</p>
    </div>
    }
    @else {
    <!-- Botón MercadoPago -->
    <div class="flex justify-center mt-auto pt-4 mb-4">
      <button type="submit" form="form-checkout" [disabled]="isLoading || form.invalid"
        class="w-full md:w-3/4 bg-metro-blue text-white rounded-xl px-3 py-2 font-semibold disabled:opacity-50">
        {{ isLoading ? 'Procesando...' : ('::Pay' | abpLocalization) }}
      </button>
    </div>
    }
  </div>
</div>